module.exports = __webpack_public_path__ + "assets/Chord3.d283d3506d6e8e97a50fa7641467f2e2.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Chord3.gmt
// module id = 912
// module chunks = 0